import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AutorizovaneSubjekty } from '../models';
// @ts-ignore
import { BankoveSpojenie } from '../models';
// @ts-ignore
import { KontaktnaKarta } from '../models';
// @ts-ignore
import { OsobaSubjektuKontext } from '../models';
// @ts-ignore
import { Subjekt } from '../models';
// @ts-ignore
import { SubjektCreate } from '../models';
/**
 * SubjektyApi - axios parameter creator
 * @export
 */
export const SubjektyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Vytvorenie nového kontaktu pre subjekt
         * @param {string} subjektId Subjekt ID
         * @param {KontaktnaKarta} kontaktnaKarta 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubjektKontaktSubjekty: async (subjektId: string, kontaktnaKarta: KontaktnaKarta, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subjektId' is not null or undefined
            assertParamExists('createSubjektKontaktSubjekty', 'subjektId', subjektId)
            // verify required parameter 'kontaktnaKarta' is not null or undefined
            assertParamExists('createSubjektKontaktSubjekty', 'kontaktnaKarta', kontaktnaKarta)
            const localVarPath = `/portal/subjekty/{subjektId}/kontakty`
                .replace(`{${"subjektId"}}`, encodeURIComponent(String(subjektId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication securityAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "securityAuth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(kontaktnaKarta, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Vytvorenie subjektu (eID autoregistrácia)
         * @param {SubjektCreate} subjektCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalAutoRegistraciaSubjektuSubjekty: async (subjektCreate: SubjektCreate, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subjektCreate' is not null or undefined
            assertParamExists('portalAutoRegistraciaSubjektuSubjekty', 'subjektCreate', subjektCreate)
            const localVarPath = `/portal/subjekty/autoregistracia`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication securityAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "securityAuth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json;charset=utf-8';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(subjektCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Vytvorenie nového bankového spojenia subjektu
         * @param {string} subjektId Subjekt ID
         * @param {BankoveSpojenie} bankoveSpojenie 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalCreateSubjektBankSpojSubjekty: async (subjektId: string, bankoveSpojenie: BankoveSpojenie, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subjektId' is not null or undefined
            assertParamExists('portalCreateSubjektBankSpojSubjekty', 'subjektId', subjektId)
            // verify required parameter 'bankoveSpojenie' is not null or undefined
            assertParamExists('portalCreateSubjektBankSpojSubjekty', 'bankoveSpojenie', bankoveSpojenie)
            const localVarPath = `/portal/subjekty/{subjektId}/bankoveSpojenia`
                .replace(`{${"subjektId"}}`, encodeURIComponent(String(subjektId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication securityAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "securityAuth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bankoveSpojenie, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Získanie zoznamu autorizovanych subjektov pre prihkáseného používateľa
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalGetAutorizovaneSubjektyListSubjekty: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/portal/subjekty/autorizovane`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication securityAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "securityAuth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Získanie zoznamu bankových spojení subjektu
         * @param {string} subjektId Subjekt ID
         * @param {string} [q] Vyhľadávacia query
         * @param {string} [stavZCykl] Stav životného cyklu
         * @param {string} [stavZCyklCas] Stav životného cyklu v čase
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalGetSubjektBankSpojListSubjekty: async (subjektId: string, q?: string, stavZCykl?: string, stavZCyklCas?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subjektId' is not null or undefined
            assertParamExists('portalGetSubjektBankSpojListSubjekty', 'subjektId', subjektId)
            const localVarPath = `/portal/subjekty/{subjektId}/bankoveSpojenia`
                .replace(`{${"subjektId"}}`, encodeURIComponent(String(subjektId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication securityAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "securityAuth", [], configuration)

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (stavZCykl !== undefined) {
                localVarQueryParameter['stavZCykl'] = stavZCykl;
            }

            if (stavZCyklCas !== undefined) {
                localVarQueryParameter['stavZCyklCas'] = (stavZCyklCas as any instanceof Date) ?
                    (stavZCyklCas as any).toISOString() :
                    stavZCyklCas;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Získanie bankového spojenia subjektu
         * @param {string} subjektId Subjekt ID
         * @param {string} bankSpojId Bankové spojenie ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalGetSubjektBankSpojSubjekty: async (subjektId: string, bankSpojId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subjektId' is not null or undefined
            assertParamExists('portalGetSubjektBankSpojSubjekty', 'subjektId', subjektId)
            // verify required parameter 'bankSpojId' is not null or undefined
            assertParamExists('portalGetSubjektBankSpojSubjekty', 'bankSpojId', bankSpojId)
            const localVarPath = `/portal/subjekty/{subjektId}/bankoveSpojenia/{bankSpojId}`
                .replace(`{${"subjektId"}}`, encodeURIComponent(String(subjektId)))
                .replace(`{${"bankSpojId"}}`, encodeURIComponent(String(bankSpojId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication securityAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "securityAuth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Získanie zoznamu kontaktov subjektu
         * @param {string} subjektId Subjekt ID
         * @param {string} [q] Vyhľadávacia query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalGetSubjektKontaktListSubjekty: async (subjektId: string, q?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subjektId' is not null or undefined
            assertParamExists('portalGetSubjektKontaktListSubjekty', 'subjektId', subjektId)
            const localVarPath = `/portal/subjekty/{subjektId}/kontakty`
                .replace(`{${"subjektId"}}`, encodeURIComponent(String(subjektId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication securityAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "securityAuth", [], configuration)

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Získanie kontaktu na subjekte
         * @param {string} subjektId Subjekt ID
         * @param {string} kontaktId Kontakt ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalGetSubjektKontaktSubjekty: async (subjektId: string, kontaktId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subjektId' is not null or undefined
            assertParamExists('portalGetSubjektKontaktSubjekty', 'subjektId', subjektId)
            // verify required parameter 'kontaktId' is not null or undefined
            assertParamExists('portalGetSubjektKontaktSubjekty', 'kontaktId', kontaktId)
            const localVarPath = `/portal/subjekty/{subjektId}/kontakty/{kontaktId}`
                .replace(`{${"subjektId"}}`, encodeURIComponent(String(subjektId)))
                .replace(`{${"kontaktId"}}`, encodeURIComponent(String(kontaktId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication securityAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "securityAuth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Získanie zoznamu kontexových osôb subjektu (pokrýva osoby primao zo Subjektu aj s Organizácie)
         * @param {string} subjektId Subjekt ID
         * @param {string} [q] Vyhľadávacia query
         * @param {string} [rola] Rola osoby na subjekte. Viaceré roly oddelené čiarkou (aplikuje sa OR logika).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalGetSubjektKontextovaOsobaListSubjekty: async (subjektId: string, q?: string, rola?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subjektId' is not null or undefined
            assertParamExists('portalGetSubjektKontextovaOsobaListSubjekty', 'subjektId', subjektId)
            const localVarPath = `/portal/subjekty/{subjektId}/osoby/kontextove`
                .replace(`{${"subjektId"}}`, encodeURIComponent(String(subjektId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication securityAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "securityAuth", [], configuration)

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (rola !== undefined) {
                localVarQueryParameter['rola'] = rola;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Získanie subjektu
         * @param {string} subjektId Subjekt ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalGetSubjektSubjekty: async (subjektId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subjektId' is not null or undefined
            assertParamExists('portalGetSubjektSubjekty', 'subjektId', subjektId)
            const localVarPath = `/portal/subjekty/{subjektId}`
                .replace(`{${"subjektId"}}`, encodeURIComponent(String(subjektId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication securityAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "securityAuth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Zneplatnenie aktívneho bankového spojenia na subjekte
         * @param {string} subjektId Subjekt ID
         * @param {string} bankSpojId Bankové spojenie ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalInvalidateSubjektBankSpojSubjekty: async (subjektId: string, bankSpojId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subjektId' is not null or undefined
            assertParamExists('portalInvalidateSubjektBankSpojSubjekty', 'subjektId', subjektId)
            // verify required parameter 'bankSpojId' is not null or undefined
            assertParamExists('portalInvalidateSubjektBankSpojSubjekty', 'bankSpojId', bankSpojId)
            const localVarPath = `/portal/subjekty/{subjektId}/bankoveSpojenia/{bankSpojId}/zneplatnenie`
                .replace(`{${"subjektId"}}`, encodeURIComponent(String(subjektId)))
                .replace(`{${"bankSpojId"}}`, encodeURIComponent(String(bankSpojId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication securityAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "securityAuth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Odstránenie kontaktu na subjekte
         * @param {string} subjektId Subjekt ID
         * @param {string} kontaktId Kontakt ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalRemoveSubjektKontaktSubjekty: async (subjektId: string, kontaktId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subjektId' is not null or undefined
            assertParamExists('portalRemoveSubjektKontaktSubjekty', 'subjektId', subjektId)
            // verify required parameter 'kontaktId' is not null or undefined
            assertParamExists('portalRemoveSubjektKontaktSubjekty', 'kontaktId', kontaktId)
            const localVarPath = `/portal/subjekty/{subjektId}/kontakty/{kontaktId}`
                .replace(`{${"subjektId"}}`, encodeURIComponent(String(subjektId)))
                .replace(`{${"kontaktId"}}`, encodeURIComponent(String(kontaktId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication securityAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "securityAuth", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Editácia bankového spojenia na subjekte
         * @param {string} subjektId Subjekt ID
         * @param {string} bankSpojId Bankové spojenie ID
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalUpdateSubjektBankSpojSubjekty: async (subjektId: string, bankSpojId: string, body: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subjektId' is not null or undefined
            assertParamExists('portalUpdateSubjektBankSpojSubjekty', 'subjektId', subjektId)
            // verify required parameter 'bankSpojId' is not null or undefined
            assertParamExists('portalUpdateSubjektBankSpojSubjekty', 'bankSpojId', bankSpojId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('portalUpdateSubjektBankSpojSubjekty', 'body', body)
            const localVarPath = `/portal/subjekty/{subjektId}/bankoveSpojenia/{bankSpojId}`
                .replace(`{${"subjektId"}}`, encodeURIComponent(String(subjektId)))
                .replace(`{${"bankSpojId"}}`, encodeURIComponent(String(bankSpojId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication securityAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "securityAuth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Editácia kontaktu na subjekte
         * @param {string} subjektId Subjekt ID
         * @param {string} kontaktId Kontakt ID
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalUpdateSubjektKontaktSubjekty: async (subjektId: string, kontaktId: string, body: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subjektId' is not null or undefined
            assertParamExists('portalUpdateSubjektKontaktSubjekty', 'subjektId', subjektId)
            // verify required parameter 'kontaktId' is not null or undefined
            assertParamExists('portalUpdateSubjektKontaktSubjekty', 'kontaktId', kontaktId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('portalUpdateSubjektKontaktSubjekty', 'body', body)
            const localVarPath = `/portal/subjekty/{subjektId}/kontakty/{kontaktId}`
                .replace(`{${"subjektId"}}`, encodeURIComponent(String(subjektId)))
                .replace(`{${"kontaktId"}}`, encodeURIComponent(String(kontaktId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication securityAuth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "securityAuth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SubjektyApi - functional programming interface
 * @export
 */
export const SubjektyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SubjektyApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Vytvorenie nového kontaktu pre subjekt
         * @param {string} subjektId Subjekt ID
         * @param {KontaktnaKarta} kontaktnaKarta 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSubjektKontaktSubjekty(subjektId: string, kontaktnaKarta: KontaktnaKarta, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KontaktnaKarta>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSubjektKontaktSubjekty(subjektId, kontaktnaKarta, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Vytvorenie subjektu (eID autoregistrácia)
         * @param {SubjektCreate} subjektCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalAutoRegistraciaSubjektuSubjekty(subjektCreate: SubjektCreate, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Subjekt>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalAutoRegistraciaSubjektuSubjekty(subjektCreate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Vytvorenie nového bankového spojenia subjektu
         * @param {string} subjektId Subjekt ID
         * @param {BankoveSpojenie} bankoveSpojenie 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalCreateSubjektBankSpojSubjekty(subjektId: string, bankoveSpojenie: BankoveSpojenie, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BankoveSpojenie>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalCreateSubjektBankSpojSubjekty(subjektId, bankoveSpojenie, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Získanie zoznamu autorizovanych subjektov pre prihkáseného používateľa
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalGetAutorizovaneSubjektyListSubjekty(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AutorizovaneSubjekty>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalGetAutorizovaneSubjektyListSubjekty(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Získanie zoznamu bankových spojení subjektu
         * @param {string} subjektId Subjekt ID
         * @param {string} [q] Vyhľadávacia query
         * @param {string} [stavZCykl] Stav životného cyklu
         * @param {string} [stavZCyklCas] Stav životného cyklu v čase
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalGetSubjektBankSpojListSubjekty(subjektId: string, q?: string, stavZCykl?: string, stavZCyklCas?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BankoveSpojenie>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalGetSubjektBankSpojListSubjekty(subjektId, q, stavZCykl, stavZCyklCas, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Získanie bankového spojenia subjektu
         * @param {string} subjektId Subjekt ID
         * @param {string} bankSpojId Bankové spojenie ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalGetSubjektBankSpojSubjekty(subjektId: string, bankSpojId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BankoveSpojenie>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalGetSubjektBankSpojSubjekty(subjektId, bankSpojId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Získanie zoznamu kontaktov subjektu
         * @param {string} subjektId Subjekt ID
         * @param {string} [q] Vyhľadávacia query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalGetSubjektKontaktListSubjekty(subjektId: string, q?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KontaktnaKarta>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalGetSubjektKontaktListSubjekty(subjektId, q, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Získanie kontaktu na subjekte
         * @param {string} subjektId Subjekt ID
         * @param {string} kontaktId Kontakt ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalGetSubjektKontaktSubjekty(subjektId: string, kontaktId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KontaktnaKarta>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalGetSubjektKontaktSubjekty(subjektId, kontaktId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Získanie zoznamu kontexových osôb subjektu (pokrýva osoby primao zo Subjektu aj s Organizácie)
         * @param {string} subjektId Subjekt ID
         * @param {string} [q] Vyhľadávacia query
         * @param {string} [rola] Rola osoby na subjekte. Viaceré roly oddelené čiarkou (aplikuje sa OR logika).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalGetSubjektKontextovaOsobaListSubjekty(subjektId: string, q?: string, rola?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OsobaSubjektuKontext>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalGetSubjektKontextovaOsobaListSubjekty(subjektId, q, rola, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Získanie subjektu
         * @param {string} subjektId Subjekt ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalGetSubjektSubjekty(subjektId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Subjekt>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalGetSubjektSubjekty(subjektId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Zneplatnenie aktívneho bankového spojenia na subjekte
         * @param {string} subjektId Subjekt ID
         * @param {string} bankSpojId Bankové spojenie ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalInvalidateSubjektBankSpojSubjekty(subjektId: string, bankSpojId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalInvalidateSubjektBankSpojSubjekty(subjektId, bankSpojId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Odstránenie kontaktu na subjekte
         * @param {string} subjektId Subjekt ID
         * @param {string} kontaktId Kontakt ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalRemoveSubjektKontaktSubjekty(subjektId: string, kontaktId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalRemoveSubjektKontaktSubjekty(subjektId, kontaktId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Editácia bankového spojenia na subjekte
         * @param {string} subjektId Subjekt ID
         * @param {string} bankSpojId Bankové spojenie ID
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalUpdateSubjektBankSpojSubjekty(subjektId: string, bankSpojId: string, body: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BankoveSpojenie>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalUpdateSubjektBankSpojSubjekty(subjektId, bankSpojId, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Editácia kontaktu na subjekte
         * @param {string} subjektId Subjekt ID
         * @param {string} kontaktId Kontakt ID
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalUpdateSubjektKontaktSubjekty(subjektId: string, kontaktId: string, body: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KontaktnaKarta>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalUpdateSubjektKontaktSubjekty(subjektId, kontaktId, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SubjektyApi - factory interface
 * @export
 */
export const SubjektyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SubjektyApiFp(configuration)
    return {
        /**
         * 
         * @summary Vytvorenie nového kontaktu pre subjekt
         * @param {string} subjektId Subjekt ID
         * @param {KontaktnaKarta} kontaktnaKarta 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubjektKontaktSubjekty(subjektId: string, kontaktnaKarta: KontaktnaKarta, options?: any): AxiosPromise<KontaktnaKarta> {
            return localVarFp.createSubjektKontaktSubjekty(subjektId, kontaktnaKarta, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Vytvorenie subjektu (eID autoregistrácia)
         * @param {SubjektCreate} subjektCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalAutoRegistraciaSubjektuSubjekty(subjektCreate: SubjektCreate, options?: any): AxiosPromise<Subjekt> {
            return localVarFp.portalAutoRegistraciaSubjektuSubjekty(subjektCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Vytvorenie nového bankového spojenia subjektu
         * @param {string} subjektId Subjekt ID
         * @param {BankoveSpojenie} bankoveSpojenie 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalCreateSubjektBankSpojSubjekty(subjektId: string, bankoveSpojenie: BankoveSpojenie, options?: any): AxiosPromise<BankoveSpojenie> {
            return localVarFp.portalCreateSubjektBankSpojSubjekty(subjektId, bankoveSpojenie, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Získanie zoznamu autorizovanych subjektov pre prihkáseného používateľa
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalGetAutorizovaneSubjektyListSubjekty(options?: any): AxiosPromise<AutorizovaneSubjekty> {
            return localVarFp.portalGetAutorizovaneSubjektyListSubjekty(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Získanie zoznamu bankových spojení subjektu
         * @param {string} subjektId Subjekt ID
         * @param {string} [q] Vyhľadávacia query
         * @param {string} [stavZCykl] Stav životného cyklu
         * @param {string} [stavZCyklCas] Stav životného cyklu v čase
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalGetSubjektBankSpojListSubjekty(subjektId: string, q?: string, stavZCykl?: string, stavZCyklCas?: string, options?: any): AxiosPromise<BankoveSpojenie> {
            return localVarFp.portalGetSubjektBankSpojListSubjekty(subjektId, q, stavZCykl, stavZCyklCas, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Získanie bankového spojenia subjektu
         * @param {string} subjektId Subjekt ID
         * @param {string} bankSpojId Bankové spojenie ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalGetSubjektBankSpojSubjekty(subjektId: string, bankSpojId: string, options?: any): AxiosPromise<BankoveSpojenie> {
            return localVarFp.portalGetSubjektBankSpojSubjekty(subjektId, bankSpojId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Získanie zoznamu kontaktov subjektu
         * @param {string} subjektId Subjekt ID
         * @param {string} [q] Vyhľadávacia query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalGetSubjektKontaktListSubjekty(subjektId: string, q?: string, options?: any): AxiosPromise<KontaktnaKarta> {
            return localVarFp.portalGetSubjektKontaktListSubjekty(subjektId, q, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Získanie kontaktu na subjekte
         * @param {string} subjektId Subjekt ID
         * @param {string} kontaktId Kontakt ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalGetSubjektKontaktSubjekty(subjektId: string, kontaktId: string, options?: any): AxiosPromise<KontaktnaKarta> {
            return localVarFp.portalGetSubjektKontaktSubjekty(subjektId, kontaktId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Získanie zoznamu kontexových osôb subjektu (pokrýva osoby primao zo Subjektu aj s Organizácie)
         * @param {string} subjektId Subjekt ID
         * @param {string} [q] Vyhľadávacia query
         * @param {string} [rola] Rola osoby na subjekte. Viaceré roly oddelené čiarkou (aplikuje sa OR logika).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalGetSubjektKontextovaOsobaListSubjekty(subjektId: string, q?: string, rola?: string, options?: any): AxiosPromise<OsobaSubjektuKontext> {
            return localVarFp.portalGetSubjektKontextovaOsobaListSubjekty(subjektId, q, rola, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Získanie subjektu
         * @param {string} subjektId Subjekt ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalGetSubjektSubjekty(subjektId: string, options?: any): AxiosPromise<Subjekt> {
            return localVarFp.portalGetSubjektSubjekty(subjektId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Zneplatnenie aktívneho bankového spojenia na subjekte
         * @param {string} subjektId Subjekt ID
         * @param {string} bankSpojId Bankové spojenie ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalInvalidateSubjektBankSpojSubjekty(subjektId: string, bankSpojId: string, options?: any): AxiosPromise<void> {
            return localVarFp.portalInvalidateSubjektBankSpojSubjekty(subjektId, bankSpojId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Odstránenie kontaktu na subjekte
         * @param {string} subjektId Subjekt ID
         * @param {string} kontaktId Kontakt ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalRemoveSubjektKontaktSubjekty(subjektId: string, kontaktId: string, options?: any): AxiosPromise<void> {
            return localVarFp.portalRemoveSubjektKontaktSubjekty(subjektId, kontaktId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Editácia bankového spojenia na subjekte
         * @param {string} subjektId Subjekt ID
         * @param {string} bankSpojId Bankové spojenie ID
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalUpdateSubjektBankSpojSubjekty(subjektId: string, bankSpojId: string, body: object, options?: any): AxiosPromise<BankoveSpojenie> {
            return localVarFp.portalUpdateSubjektBankSpojSubjekty(subjektId, bankSpojId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Editácia kontaktu na subjekte
         * @param {string} subjektId Subjekt ID
         * @param {string} kontaktId Kontakt ID
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalUpdateSubjektKontaktSubjekty(subjektId: string, kontaktId: string, body: object, options?: any): AxiosPromise<KontaktnaKarta> {
            return localVarFp.portalUpdateSubjektKontaktSubjekty(subjektId, kontaktId, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SubjektyApi - object-oriented interface
 * @export
 * @class SubjektyApi
 * @extends {BaseAPI}
 */
export class SubjektyApi extends BaseAPI {
    /**
     * 
     * @summary Vytvorenie nového kontaktu pre subjekt
     * @param {string} subjektId Subjekt ID
     * @param {KontaktnaKarta} kontaktnaKarta 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubjektyApi
     */
    public createSubjektKontaktSubjekty(subjektId: string, kontaktnaKarta: KontaktnaKarta, options?: AxiosRequestConfig) {
        return SubjektyApiFp(this.configuration).createSubjektKontaktSubjekty(subjektId, kontaktnaKarta, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Vytvorenie subjektu (eID autoregistrácia)
     * @param {SubjektCreate} subjektCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubjektyApi
     */
    public portalAutoRegistraciaSubjektuSubjekty(subjektCreate: SubjektCreate, options?: AxiosRequestConfig) {
        return SubjektyApiFp(this.configuration).portalAutoRegistraciaSubjektuSubjekty(subjektCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Vytvorenie nového bankového spojenia subjektu
     * @param {string} subjektId Subjekt ID
     * @param {BankoveSpojenie} bankoveSpojenie 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubjektyApi
     */
    public portalCreateSubjektBankSpojSubjekty(subjektId: string, bankoveSpojenie: BankoveSpojenie, options?: AxiosRequestConfig) {
        return SubjektyApiFp(this.configuration).portalCreateSubjektBankSpojSubjekty(subjektId, bankoveSpojenie, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Získanie zoznamu autorizovanych subjektov pre prihkáseného používateľa
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubjektyApi
     */
    public portalGetAutorizovaneSubjektyListSubjekty(options?: AxiosRequestConfig) {
        return SubjektyApiFp(this.configuration).portalGetAutorizovaneSubjektyListSubjekty(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Získanie zoznamu bankových spojení subjektu
     * @param {string} subjektId Subjekt ID
     * @param {string} [q] Vyhľadávacia query
     * @param {string} [stavZCykl] Stav životného cyklu
     * @param {string} [stavZCyklCas] Stav životného cyklu v čase
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubjektyApi
     */
    public portalGetSubjektBankSpojListSubjekty(subjektId: string, q?: string, stavZCykl?: string, stavZCyklCas?: string, options?: AxiosRequestConfig) {
        return SubjektyApiFp(this.configuration).portalGetSubjektBankSpojListSubjekty(subjektId, q, stavZCykl, stavZCyklCas, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Získanie bankového spojenia subjektu
     * @param {string} subjektId Subjekt ID
     * @param {string} bankSpojId Bankové spojenie ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubjektyApi
     */
    public portalGetSubjektBankSpojSubjekty(subjektId: string, bankSpojId: string, options?: AxiosRequestConfig) {
        return SubjektyApiFp(this.configuration).portalGetSubjektBankSpojSubjekty(subjektId, bankSpojId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Získanie zoznamu kontaktov subjektu
     * @param {string} subjektId Subjekt ID
     * @param {string} [q] Vyhľadávacia query
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubjektyApi
     */
    public portalGetSubjektKontaktListSubjekty(subjektId: string, q?: string, options?: AxiosRequestConfig) {
        return SubjektyApiFp(this.configuration).portalGetSubjektKontaktListSubjekty(subjektId, q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Získanie kontaktu na subjekte
     * @param {string} subjektId Subjekt ID
     * @param {string} kontaktId Kontakt ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubjektyApi
     */
    public portalGetSubjektKontaktSubjekty(subjektId: string, kontaktId: string, options?: AxiosRequestConfig) {
        return SubjektyApiFp(this.configuration).portalGetSubjektKontaktSubjekty(subjektId, kontaktId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Získanie zoznamu kontexových osôb subjektu (pokrýva osoby primao zo Subjektu aj s Organizácie)
     * @param {string} subjektId Subjekt ID
     * @param {string} [q] Vyhľadávacia query
     * @param {string} [rola] Rola osoby na subjekte. Viaceré roly oddelené čiarkou (aplikuje sa OR logika).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubjektyApi
     */
    public portalGetSubjektKontextovaOsobaListSubjekty(subjektId: string, q?: string, rola?: string, options?: AxiosRequestConfig) {
        return SubjektyApiFp(this.configuration).portalGetSubjektKontextovaOsobaListSubjekty(subjektId, q, rola, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Získanie subjektu
     * @param {string} subjektId Subjekt ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubjektyApi
     */
    public portalGetSubjektSubjekty(subjektId: string, options?: AxiosRequestConfig) {
        return SubjektyApiFp(this.configuration).portalGetSubjektSubjekty(subjektId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Zneplatnenie aktívneho bankového spojenia na subjekte
     * @param {string} subjektId Subjekt ID
     * @param {string} bankSpojId Bankové spojenie ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubjektyApi
     */
    public portalInvalidateSubjektBankSpojSubjekty(subjektId: string, bankSpojId: string, options?: AxiosRequestConfig) {
        return SubjektyApiFp(this.configuration).portalInvalidateSubjektBankSpojSubjekty(subjektId, bankSpojId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Odstránenie kontaktu na subjekte
     * @param {string} subjektId Subjekt ID
     * @param {string} kontaktId Kontakt ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubjektyApi
     */
    public portalRemoveSubjektKontaktSubjekty(subjektId: string, kontaktId: string, options?: AxiosRequestConfig) {
        return SubjektyApiFp(this.configuration).portalRemoveSubjektKontaktSubjekty(subjektId, kontaktId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Editácia bankového spojenia na subjekte
     * @param {string} subjektId Subjekt ID
     * @param {string} bankSpojId Bankové spojenie ID
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubjektyApi
     */
    public portalUpdateSubjektBankSpojSubjekty(subjektId: string, bankSpojId: string, body: object, options?: AxiosRequestConfig) {
        return SubjektyApiFp(this.configuration).portalUpdateSubjektBankSpojSubjekty(subjektId, bankSpojId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Editácia kontaktu na subjekte
     * @param {string} subjektId Subjekt ID
     * @param {string} kontaktId Kontakt ID
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubjektyApi
     */
    public portalUpdateSubjektKontaktSubjekty(subjektId: string, kontaktId: string, body: object, options?: AxiosRequestConfig) {
        return SubjektyApiFp(this.configuration).portalUpdateSubjektKontaktSubjekty(subjektId, kontaktId, body, options).then((request) => request(this.axios, this.basePath));
    }
}
